export function updateSwiperStatus(swiper) {
  const statusEl = swiper.el.querySelector('.swiper-status');
  if (!statusEl) return;

  const total = swiper.slides.length;

  let perView = swiper.params.slidesPerView;
  if (perView === 'auto') {
    perView = swiper.slidesPerViewDynamic();
  }
  if (typeof perView !== 'number' || perView <= 0) perView = 1;

  const current = swiper.realIndex + 1;

  let message;

  if (perView === 1) {
    message = Shopify.locale === 'uk'
      ? `Слайд ${current} з ${total}`
      : `Слайд ${current} из ${total}`;
  }
  else {
    const start = current;
    const end = Math.min(start + perView - 1, total);

    message = Shopify.locale === 'uk'
        ? `Слайди ${start}–${end} з ${total}`
        : `Слайды ${start}–${end} из ${total}`;
  }

  statusEl.textContent = message;
}

export function updateSlidesInert(swiper, mode = 'visible') {
  swiper.slides.forEach((slide, index) => {
    const isActive =
      mode === 'active'
        ? index === swiper.activeIndex
        : slide.classList.contains('swiper-slide-visible');

    if (isActive) {
      slide.removeAttribute('inert');
      slide.removeAttribute('aria-hidden');
    } else {
      slide.setAttribute('inert', '');
      slide.setAttribute('aria-hidden', 'true');
    }
  });
}